// Loads the YouTube IFrame Player API script exactly once, no matter how
// many VideoWatchOverlay instances (or remounts, e.g. React StrictMode)
// call this - the script itself calls the global `onYouTubeIframeAPIReady`
// callback exactly once when it's ready, so every caller shares one cached
// promise instead of each racing to set/overwrite that global.

let apiPromise = null;

export function loadYouTubeApi() {
  if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
  if (apiPromise) return apiPromise;

  apiPromise = new Promise((resolve) => {
    const previousCallback = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (previousCallback) previousCallback();
      resolve(window.YT);
    };

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  });

  return apiPromise;
}
